import { render } from "./HolidayCalendar.vue?vue&type=template&id=02359643&scoped=true"
import script from "./HolidayCalendar.vue?vue&type=script&lang=js"
export * from "./HolidayCalendar.vue?vue&type=script&lang=js"

import "./HolidayCalendar.vue?vue&type=style&index=0&id=02359643&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02359643"]])

export default __exports__